import React, { Component } from 'react';
import MetricsIllusPerformance from 'img/ucd_project_metrics_illus_performance.svg';
import _ from 'lodash';

class NoMetrics extends Component {
  render() {
    const { headerText, bodyText } = this.props;
    return (
      <div style={{ paddingTop: 110 }}>
        <img
          src={MetricsIllusPerformance}
          alt="icon"
          width={130}
          height={130}
          style={{
            display: 'block',
            margin: 'auto',
            width: 130,
            height: 130,
            marginBottom: 32,
          }}
        />
        <p
          style={{
            textAlign: 'center',
            fontSize: '24px',
            fontWeight: 500,
            color: '#A3A3A3',
            marginBottom: 8,
          }}
        >
          {!_.isEmpty(headerText) ? headerText : 'Data is not ready yet'}
        </p>
        <p
          style={{
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: 400,
            color: '#A3A3A3',
            marginBottom: 32,
            whiteSpace: 'pre-line',
          }}
        >
          {!_.isEmpty(bodyText) ? bodyText : 'When data is ready, it will show up here.'}
        </p>
      </div>);
  }
}

export default NoMetrics;
